import { NewGlassBoardConfigurator as New } from './components/Configurator';

// TODO koment na prod
//import './App.css';
import { ConfigProvider } from './components/ConfigContext';

function App() {
  return (
    <div className="App">
      <ConfigProvider>
        <New />
      </ConfigProvider>
    </div>
  );
}

export default App;
